<template>
    <rkm-layout-body title="Lista de classificação de risco">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'pronto-atendimento-classificacao-risco-create' })"
                color="primary"
                authorize="store-pronto-atendimento-classificacao-risco"
            >
                Cadastrar classificação de risco
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/pronto-atendimento/classificacao-risco/List'

export default {
    components: { List },
}
</script>